import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const quickCategories = categories.slice(0, 8);

  return (
    <footer className="bg-accent-900 text-white">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            <div className="lg:col-span-1">
              <Link to="/" className="inline-block cursor-pointer">
                <span className="font-heading text-2xl font-semibold text-white">
                  Kakobuy<span className="text-accent-300">Finds</span>
                </span>
              </Link>
              <p className="mt-4 text-sm text-accent-200 leading-relaxed max-w-xs">
                The independent resource for discovering the best Kakobuy spreadsheet finds, shopping guides, and product databases. Updated weekly with curated recommendations.
              </p>
              <p className="mt-4 text-xs text-accent-300 italic">
                Independent research website. Not affiliated with Kakobuy, CSSBuy, Superbuy or Oopbuy.
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Quick Categories</h4>
              <ul className="space-y-2.5">
                {quickCategories.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">SEO Guides</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/kakobuy-spreadsheet-guide" className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Complete Spreadsheet Guide
                  </Link>
                </li>
                <li>
                  <Link to="/kakobuy-spreadsheet-finds" className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Best Kakobuy Finds 2026
                  </Link>
                </li>
                <li>
                  <Link to="/kakobuy-spreadsheet-beginners" className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Beginners Tutorial
                  </Link>
                </li>
                <li>
                  <Link to="/spreadsheet-comparison" className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Platform Comparison Hub
                  </Link>
                </li>
                <li>
                  <Link to="/kakobuy-spreadsheet-download" className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Download Sheet
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Comparisons</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/kakobuy-vs-cssbuy" className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Kakobuy vs CSSBuy
                  </Link>
                </li>
                <li>
                  <Link to="/kakobuy-vs-superbuy" className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Kakobuy vs Superbuy
                  </Link>
                </li>
                <li>
                  <Link to="/kakobuy-vs-oopbuy" className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Kakobuy vs Oopbuy
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    Home
                  </Link>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-accent-200 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    Kakobuy Sheet Main Site
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-accent-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-accent-300">
              &copy; {new Date().getFullYear()} KakobuyFinds.sbs. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-lg border border-accent-600 text-accent-200 hover:text-white hover:border-accent-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-global-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-lg border border-accent-600 text-accent-200 hover:text-white hover:border-accent-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}